const PEC = JSON.parse(sessionStorage.getItem("labels_config"));
export const EventReasonCodeMapping = {
  "E-020-R-0046": "Shipment Created",
  "E-012-R-0095": "Added to dispatch",
  "E-012-R-0099": "Customer Call Placed",
  "E-012-R-0067": "Container Associated With New Workorder",
  "E-013-R-0059": "Entity Reopened By Client",
  "E-021-R-0063": "Picked Up",
  "E-006-R-0063": "Picked Up",
  "E-010-R-0041": "Delivered To Consignee",
  "E-010-R-0042": "Delivered To Security",
  "E-010-R-0043": "Delivered to Other As Per Consignee",
  "E-021-R-0013": "Delivery Rescheduled",
  "E-021-R-0020": "Payment Mode/Amount Dispute",
  "E-021-R-0022": "Customer Asked For Open Delivery",
  "E-021-R-0023": "Consignee Opened Package And Refused To Accept",
  "E-021-R-0024": "Entry Restricted Area",
  "E-021-R-0025": "Address Quality Issue",
  "E-021-R-0026": "Not Attempted",
  "E-021-R-0027": "Consignee Refused Order",
  "E-021-R-0028": "Consignee Seized Package",
  "E-021-R-0029": "Consignee Not Available",
  "E-021-R-0035": "Delivery Unsuccessful",
  "E-021-R-0036": "Delivery Unsuccessful",
  // "E-011-R-0066": "Attempt count exhausted",
  "E-011-R-0058": "Cancelled as per client request",
  "E-011-R-0102": "Cancelled as per consignee request",
  "E-019-R-0082": "Job Creation Failed",
  "E-012-R-0068": "Rider Assigned",
  "E-005-R-0068": "Rider Assigned",
  "E-005-R-0068": "Rider Assigned",
  "E-040-R-0121": "Consignor Refused Order",
  "E-040-R-0120": "Consignor Not Available",
  "E-040-R-0026": "Not Attempted",
  "E-040-R-0071": "Failed",
  "E-021-R-3001": "Customer Issue : Needs loading and unloading",
  "E-021-R-3002": "Customer Issue : Wrong pickup or drop location selected",
  "E-021-R-3003": "Customer Issue : Not able to contact customer",
  "E-021-R-3004": "Customer Issue : Placed the order by mistake",
  "E-021-R-3005": "Driver Issue : Driver refused pickup or unreachable",
  "E-021-R-3006": "Driver Issue : Driver behavior or vehicle issues",
  "E-021-R-3007": "Pickup time was too long",
  "E-040-R-0131": "Payment unsuccessful",
  "E-021-R-0131": "Payment unsuccessful",
  "E-021": "",
  "E-040": "",
};

export const deliveryStates = {
  "E-010-R-0041": "Delivered To Consignee",
  "E-010-R-0042": "Delivered To Security",
  "E-010-R-0043": "Delivered to Other As Per Consignee",
  "E-021-R-0013": "Delivery Rescheduled",
  "E-021-R-0020": "Payment Mode/Amount Dispute",
  "E-021-R-0022": "Customer Asked For Open Delivery",
  "E-021-R-0023": "Consignee Opened Package And Refused To Accept",
  "E-021-R-0024": "Entry Restricted Area",
  "E-021-R-0025": "Address Quality Issue",
  "E-021-R-0026": "Not Attempted",
  "E-021-R-0027": "Consignee Refused Order",
  "E-021-R-0028": "Consignee Seized Package",
  "E-021-R-0029": "Consignee Unavailable",
  "E-021-R-0035": "Delivery Unsuccessful",
  "E-021-R-0036": "Delivery Unsuccessful",
  "E-021-R-0035": "Delivery failed",
  "E-021-R-0036": "Delivery failed",
  "E-021-R-3001": "Customer Issue : Needs loading and unloading",
  "E-021-R-3002": "Customer Issue : Wrong pickup or drop location selected",
  "E-021-R-3003": "Customer Issue : Not able to contact customer",
  "E-021-R-3004": "Customer Issue : Placed the order by mistake",
  "E-021-R-3005": "Driver Issue : Driver refused pickup or unreachable",
  "E-021-R-3006": "Driver Issue : Driver behavior or vehicle issues",
  "E-021-R-3007": "Pickup time was too long",
  "E-021-R-0131": "Payment unsuccessful"
};

export const cancelledStates = ["E-011-R-0058"];

export const pickUpStates = {
  "E-020-R-0046": "Shipment Created",
  "E-021-R-0063": "Picked Up",
  "E-006-R-0063": "Picked Up",
};

export const pickupSuccessStates = ["E-021-R-0063", "E-006-R-0063"];
export const pickupOngoingStates = [];

export const deliverySuccessStates = [
  "E-010-R-0041",
  "E-010-R-0042",
  "E-010-R-0043",
  // "E-012-R-0096",
];

export const pickupFailedStates = [
  "E-040-R-0120",
  "E-040-R-0121",
  "E-040-R-0071",
  "E-040-R-0026",
  "E-040-R-0131",
  "E-040",
];

export const returnSucessStates = [...deliverySuccessStates];

export const returnActiveStates = [];

export const deliveryActiveStates = [];
export const deliveryFailedStates = [
  "E-021-R-0013",
  "E-021-R-0014",
  // "E-021-R-0020",
  // "E-021-R-0023",
  // "E-021-R-0024",
  // "E-021-R-0025",
  "E-021-R-0026",
  "E-021-R-0027",
  "E-021-R-0029",
  "E-011-R-0066",
  "E-021-R-3001",
  "E-021-R-3002",
  "E-021-R-3003",
  "E-021-R-3004",
  "E-021-R-3005",
  "E-021-R-3006",
  "E-021-R-3007",
  "E-021-R-0131",
  "E-021",
  // "E-021-R-0035",
  // "E-021-R-0036",
  // "E-020-R-0069",
];

export const returnFailedStates = [...deliveryFailedStates];

export const deliveryCompleteFailed = ["E-013-R-0069"];

export const jobCompleteFailed = [...deliveryCompleteFailed];

// export const riderAssignedStates = {
//   ASSIGNED: "ASSIGNED",
//   IN_PROGRESS: "IN_PROGRESS",
//   COMPLETED: "COMPLETED",
//   ALLOCATED: "ALLOCATED",
// };
export const riderAssignedStates = ["E-012-R-0068", "E-005-R-0068"];
export const miscStates = {
  SUCCESS: ["E-012-R-0065"],
  FAILURE: ["E-020-R-0069", "E-012-R-0064", "E-011-R-0066"],
};

export const closedStates = ["E-013-R-0069", "E-011-R-0066"];

export const consignmentStates = {
  rider: [...riderAssignedStates],
  pickup: [
    ...pickupOngoingStates,
    ...pickupSuccessStates,
    ...pickupFailedStates,
  ],
  delivery: [
    ...deliveryActiveStates,
    ...deliveryFailedStates,
    ...deliverySuccessStates,
  ],
  misc: [...miscStates.SUCCESS, ...miscStates.FAILURE],

  // Added new state for return

  reverse: [
    ...deliveryActiveStates,
    ...deliveryFailedStates,
    ...deliverySuccessStates,
  ], // to do Will add array of code here
};

// export const outForDeliveryStates = {
// 	"E-021-R-0024": "Entry Restricted Area",
// 	"E-021-R-0025": "Address Quality Issue",
// 	"E-021-R-0026": "Not Attempted",
// };
